export default __webpack_public_path__ + "static/media/labels_price_original.558c62cb.jpg";